import { render, staticRenderFns } from "./CopyField.vue?vue&type=template&id=0cd4a6d3&scoped=true"
import script from "./CopyField.vue?vue&type=script&lang=js"
export * from "./CopyField.vue?vue&type=script&lang=js"
import style0 from "./CopyField.vue?vue&type=style&index=0&id=0cd4a6d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd4a6d3",
  null
  
)

export default component.exports